export function scrollUp () {
  document.querySelector('main').scrollTo({ top: 0, behavior: 'smooth' })
}

export function scrollToStartNode (node) {
  node.scrollIntoView({ block: 'start', behavior: 'smooth' })
}
